export interface EventLogDetails {
  eventId?: string | null;
  date?: string | null;
  type?: string | null;
  source?: string | null;
  change?: string | null;
  comment?: string | null;
}

export function getHoldStateRegisterId(stateValue: string): number | null {
  if (stateValue === "Hold Open") return 202;
  if (stateValue === "Hold Close") return 203;
  return null;
}

export function shouldShowHoldStateComment(stateValue: string): boolean {
  return stateValue === "Hold Open" || stateValue === "Hold Close";
}

export async function fetchEventLogDetails(
  assetId: string,
  state: number,
  timeZoneId: string
): Promise<EventLogDetails> {
  const baseUrl = process.env.REACT_APP_SERVER_ENDPOINT;
  const params = new URLSearchParams({
    assetId,
    userTimeZone: timeZoneId,
    state: String(state),
  });

  const response = await fetch(`${baseUrl}/EventLog/GetEventLogDetails?${params}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("jwtAccessToken")}`,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`GetEventLogDetails failed with status ${response.status}`);
  }

  return response.json();
}

/*
 * holdStateEventLog.tsx
 *
 * Shared helpers for Hold Open / Hold Close comment tooltips on the summary table.
 * Used by SortTable (desktop) and SortTableMobile (mobile).
 *
 * - Maps display state text to API register IDs (Hold Open → 202, Hold Close → 203)
 * - Determines when the chat-bubble icon should appear
 * - Fetches latest event log details via GET /EventLog/GetEventLogDetails
 *
 * UI (icon, tooltip/modal, toggle, loading) lives in the table components, not here.
 */